import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useToken } from "../../../Component/Context/useToken";
import { fontStyles } from "../../../Component/style/common_font";
import {
  CenterView,
  Icon,
  RowView,
  RowView2,
} from "../../../Component/style/common_style";
import Footer from "../../../Component/UI/Footer";
import Layout_user from "../../../Component/UI/Layout_user";
import SearchSubmitButton from "../../../Component/UI/SearchSubmitButton";
import UserLiveList from "./UserLiveList";
import SideBar from "./Component/SideBar";
import LoginModal from "../Sign/Modal/LoginModal";
import Block from "../Live/modal/Block";
import url, { SERVER_ADDRESS } from "../../../Component/server";
import api, { restoreSession } from '../../../Component/axios_Interceptor/api';
import { AttentionDot, customerHistoryUrl } from './OrderHistory';
import { hasUnreadOrderAttention, orderAttentionReadEvent } from './orderAttention';

const Home = () => {
  const Navigate = useNavigate();

  const { logout } = useToken();

  const [storeSearch, setStoreSearch] = useState("");
  const [isLogin, setisLogin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [blockModal, setBlockModal] = useState(false);
  const handleBlockModal = () => {
    setBlockModal(!blockModal);
  };
  const [ban_popup, setBan_popup] = useState("");
  const [homeBanners, setHomeBanners] = useState<{seq: number; title: string; image_path: string; link_url?: string}[]>([]);

  const [loginModalVisible, setLoginModalVisible] = useState(false);
  const handleLoginModalVisible = () => {
    setLoginModalVisible(!loginModalVisible);
  };

  useEffect(() => {
    let active = true;
    const verify = async () => {
      const token = await restoreSession();
      if (active) { setisLogin(!!token); setLoading(false); }
    };
    void verify();
    window.addEventListener('focus', verify);
    return () => { active = false; window.removeEventListener('focus', verify); };
  }, []);

  useEffect(() => {
    let active = true;
    axios.get(url.Communication_url.home_banners)
      .then(response => {
        if (!active) return;
        setHomeBanners(Array.isArray(response.data?.items) ? response.data.items : []);
      })
      .catch(() => {
        if (active) setHomeBanners([]);
      });
    return () => { active = false; };
  }, []);

  useEffect(() => {
    // 우클릭 금지
    const originalOnContextMenu = document.oncontextmenu;
    document.oncontextmenu = function () {
      return false;
    };

    return () => {
      document.oncontextmenu = originalOnContextMenu;
    };
  }, []);

  // 사이드바
  const [sideBarVisible, setSideBarVisible] = useState(false);
  const [sidebarOn, setSidebarOn] = useState(false);
  const [orderAttention, setOrderAttention] = useState(false);
  const [orderAttentionError, setOrderAttentionError] = useState(false);
  useEffect(() => {
    if (!isLogin) { setOrderAttention(false); setOrderAttentionError(false); return; }
    let active = true;
    let sequence = 0;
    let controller: AbortController | undefined;
    const refresh = async () => {
      if (document.visibilityState === 'hidden') return;
      controller?.abort(); controller = new AbortController();
      const request = ++sequence;
      try {
        const { data } = await api.get(customerHistoryUrl, { params: { page: 1 }, signal: controller.signal });
        if (!active || request !== sequence) return;
        if (!Number.isSafeInteger(data?.attention_count) || data.attention_count < 0) throw new Error('Invalid payment attention');
        setOrderAttention(hasUnreadOrderAttention(data)); setOrderAttentionError(false);
      } catch {
        if (active && request === sequence) setOrderAttentionError(true);
      }
    };
    void refresh();
    const onFocus = () => { void refresh(); };
    const timer = window.setInterval(onFocus, 60000);
    window.addEventListener('focus', onFocus);
    window.addEventListener(orderAttentionReadEvent, onFocus);
    window.addEventListener('storage', onFocus);
    document.addEventListener('visibilitychange', onFocus);
    return () => { active = false; controller?.abort(); window.clearInterval(timer); window.removeEventListener('focus', onFocus); window.removeEventListener(orderAttentionReadEvent, onFocus); window.removeEventListener('storage', onFocus); document.removeEventListener('visibilitychange', onFocus); };
  }, [isLogin, sidebarOn]);
  const handleSidebarToggle = () => {
    setSidebarOn(!sidebarOn);
    setSideBarVisible(true);
  };

  return (
    <Layout_user>
      <HomePage>
        {sideBarVisible && (
          <SideBar
            handleSidebarToggle={handleSidebarToggle}
            isVisible={sidebarOn}
            isLogin={isLogin}
            onLogout={() => logout("")}
            hasOrderAttention={orderAttention}
            orderAttentionError={orderAttentionError}
          />
        )}
        <Topbar>
          <RowView>
            <Logo src={require("../../../Image/Logo_Text.png")} />
          </RowView>
          {loading ? (
            <div className="loading" />
          ) : (
            <RowView2>
              {!isLogin && (
                <Btn onClick={handleLoginModalVisible}>로그인</Btn>
              )}
              <MenuButton type="button" onClick={handleSidebarToggle} aria-label={orderAttention ? '메뉴, 입금 기한 확인이 필요한 주문이 있습니다' : '메뉴'} aria-expanded={sidebarOn}>
                <Icon src={require("../../../Image/ic_hamburger_white.png")} alt="" />
                {isLogin && orderAttention && <AttentionDot aria-hidden="true" />}
              </MenuButton>
            </RowView2>
          )}
        </Topbar>

        {homeBanners.length > 0 && (
          <HomeBannerArea>
            {homeBanners.map((banner) => (
              <HomeBanner
                key={banner.seq}
                $wide={banner.image_path === "/fanbird-intro-banner.svg"}
                href={banner.link_url && (/^https?:\/\//.test(banner.link_url) || /^\/(?!\/)/.test(banner.link_url)) ? banner.link_url : undefined}
                target={banner.link_url?.startsWith("http") ? "_blank" : undefined}
                rel="noopener noreferrer"
              >
                <img src={banner.image_path.startsWith("http") || banner.image_path.startsWith("/") ? banner.image_path : `${SERVER_ADDRESS}openfile/${banner.image_path}`} alt={banner.title} />
              </HomeBanner>
            ))}
          </HomeBannerArea>
        )}

        <SearchArea>
          <SearchTitle>찾으시는 스토어가 있다면?</SearchTitle>
          <SearchBox role="search" aria-label="스토어 검색" onSubmit={event => {
            event.preventDefault();
            Navigate("/search", { state: { searchText: storeSearch.trim() } });
          }}>
            <Icon src={require("../../../Image/ic_find_black.png")} style={{ width: 20, filter: "var(--user-icon-filter)" }} />
            <SearchInput
              type="text"
              aria-label="스토어명"
              placeholder="스토어명을 입력해주세요."
              enterKeyHint="search"
              value={storeSearch}
              onChange={event => setStoreSearch(event.target.value)}
              onKeyDown={event => { if (event.key === "Enter" && (event.nativeEvent.isComposing || event.keyCode === 229)) event.preventDefault(); }}
            />
            <SearchSubmitButton type="submit">검색</SearchSubmitButton>
          </SearchBox>
        </SearchArea>

        <UserLiveList
          isLogin={isLogin}
          key={isLogin ? "loggedIn" : "loggedOut"}
        />

        <Footer />
        <LoginModal
          handleModal={handleLoginModalVisible}
          visible={loginModalVisible}
          setTryLogin={setisLogin}
          setLoading={setLoading}
          setBlockModal={setBlockModal}
        />
        <Block
          visible={blockModal}
          handleModal={handleBlockModal}
          ban_popup={ban_popup}
        />
      </HomePage>
    </Layout_user>
  );
};

export default Home;

const HomePage = styled.div`
  position: relative;
  overflow: clip;
  display: flex;
  flex-direction: column;
  min-height: var(--browser-layout-height, 100dvh);
`;

const MenuButton = styled.button`
  position:relative;display:flex;align-items:center;justify-content:center;width:44px;height:44px;padding:8px;border:0;background:transparent;cursor:pointer;
  > img { filter: var(--user-icon-filter); }
  > span { position:absolute;top:5px;right:3px; }
  &:focus-visible { outline:3px solid #a78cff;outline-offset:2px; }
`;

const Topbar = styled(RowView)`
  z-index: 99;
  box-sizing: border-box;
  position: sticky;
  width: 100%;
  top: 0;
  max-width: 500px;
  background-color: var(--user-surface);
  padding: 15px;
  padding-left: 16px;

  div.loading {
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    border: 3px solid #7955f0;
    border-top-color: #9c9c9c;
    border-radius: 100%;
    animation: spin 1s ease-in-out infinite;
  }
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Btn = styled(CenterView)`
  margin-right: 10px;
  padding: 0px 15px;
  ${fontStyles.semiBold}
  cursor: pointer;
  @media ${({ theme }) => theme.small} {
    font-size: 15px;
  }
`;

const Logo = styled(Icon)`
  height: 44px;
  margin-right: 5px;
  @media ${({ theme }) => theme.small} {
    height: 2rem;
  }
  border-radius: 4px;
`;

const SearchArea = styled.div`
  padding: 16px;
  margin-top: 10px;
`;

const HomeBannerArea = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  overflow-x: auto;
  padding: 16px 16px 0;
  scroll-snap-type: x mandatory;
  scroll-padding-inline: 16px;
`;

const HomeBanner = styled.a<{ $wide: boolean }>`
  display: block;
  flex: 0 0 100%;
  min-width: 0;
  border: 0;
  padding: 0;
  aspect-ratio: ${props => props.$wide ? "25 / 7" : "16 / 7"};
  border-radius: 8px;
  overflow: hidden;
  background: var(--user-surface-raised);
  cursor: pointer;
  scroll-snap-align: start;
  &:focus-visible { outline: 3px solid #f7e340; outline-offset: 3px; }
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const SearchTitle = styled.div`
  color: var(--user-text);
  font-size: 16px;
  font-family: var(--font-Pretendard-SemiBold);
  margin-bottom: 12px;
`;

const SearchBox = styled.form`
  display: flex;
  flex-direction: row;
  background-color: var(--user-surface-raised);
  border-radius: 8px;
  border: 1px solid var(--user-border);
  width: 100%;
  height: 50px;
  align-items: center;
  padding: 2px 2px 2px 12px;
  gap: 10px;
  > img { flex-shrink: 0; }
  box-sizing: border-box;
`;

const SearchInput = styled.input`
  min-width: 0;
  flex: 1;
  font-size: 14px;
  color: var(--user-text);
  background-color: transparent;
  border: none;
  outline: none;
  &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 2px; }
  width: 100%;
  &::placeholder {
    color: var(--user-text-muted);
  }
`;
